/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_MinorInputs */



/**
* | output |
* | --- |
* | "Minor" |
*
* @param {Sanction_Sub_MinorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_minor = /** @type {((inputs?: Sanction_Sub_MinorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_MinorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mineure")
	if (locale === "es") return /** @type {LocalizedString} */ ("Menor")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Menor")
	if (locale === "it") return /** @type {LocalizedString} */ ("Minore")
	return /** @type {LocalizedString} */ ("Minor")
});